import type { Export1cResult, FinPaymentRequestRow } from '@shared/api';
import { Export1CModal } from '../Export1CModal';
import { CreatePaymentRequestModal } from '../CreatePaymentRequestModal';
import { CreateRegistryModal } from '../CreateRegistryModal';
import { ImportRegistry1CModal } from '../ImportRegistry1CModal';
import { ReconcileStatementsModal } from '../ReconcileStatementsModal';
import { MarkPaidModal } from '../MarkPaidModal';

interface RequestsModalsProps {
  exportResult: Export1cResult | null;
  onCloseExport: () => void;
  createModalOpen: boolean;
  onCloseCreateModal: () => void;
  createRegistryOpen: boolean;
  onCloseCreateRegistry: () => void;
  onRegistryCreated: (id: string) => void;
  importModalOpen: boolean;
  onCloseImportModal: () => void;
  reconcileModalOpen: boolean;
  onCloseReconcileModal: () => void;
  markPaidItem: FinPaymentRequestRow | null;
  onCloseMarkPaidItem: () => void;
  selectedRegistryId: string;
  onSuccess: () => void;
}

export function RequestsModals({
  exportResult,
  onCloseExport,
  createModalOpen,
  onCloseCreateModal,
  createRegistryOpen,
  onCloseCreateRegistry,
  onRegistryCreated,
  importModalOpen,
  onCloseImportModal,
  reconcileModalOpen,
  onCloseReconcileModal,
  markPaidItem,
  onCloseMarkPaidItem,
  selectedRegistryId,
  onSuccess,
}: RequestsModalsProps) {
  const activeRegistryId = selectedRegistryId !== 'all' ? selectedRegistryId : undefined;

  return (
    <>
      <Export1CModal
        open={Boolean(exportResult)}
        onClose={onCloseExport}
        exportResult={exportResult}
      />

      <CreatePaymentRequestModal
        open={createModalOpen}
        onClose={onCloseCreateModal}
        activeRegistryId={activeRegistryId}
        onSuccess={onSuccess}
      />

      <CreateRegistryModal
        open={createRegistryOpen}
        onClose={onCloseCreateRegistry}
        onCreated={onRegistryCreated}
      />

      <ImportRegistry1CModal
        open={importModalOpen}
        onClose={onCloseImportModal}
        activeRegistryId={activeRegistryId}
        onSuccess={onSuccess}
      />

      <ReconcileStatementsModal
        open={reconcileModalOpen}
        onClose={onCloseReconcileModal}
        activeRegistryId={activeRegistryId}
        onSuccess={onSuccess}
      />

      <MarkPaidModal
        open={Boolean(markPaidItem)}
        onClose={onCloseMarkPaidItem}
        request={markPaidItem}
        onSuccess={onSuccess}
      />
    </>
  );
};
